import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TextInfo, {
  TEXT_INFO_KIND,
  TEXT_INFO_COLOR,
  TEXT_INFO_ALIGN,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_HEADING_LEVEL,
} from '@gcloud-npm/next12.components.text-info';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import { SendSondaComponentNotShown } from '@/utils/functions';
import { useDispatch } from 'react-redux';
import styles from './styles';

const ModuloContratar = (props) => {
  const dispatch = useDispatch();
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!props) {
      const componentName = 'ModuloContratar';
      SendSondaComponentNotShown(componentName, dispatch);
      return null;
    }
  }, []);

  const { sectionLeft, sectionRight } = props;

  return (
    <>
      <div className="moduloContratar container">
        <div className="sectionLeft">
          <TextInfo
            text={sectionLeft.title}
            kind={TEXT_INFO_KIND.HEADING}
            level={TEXT_INFO_HEADING_LEVEL.H2}
            align={TEXT_INFO_ALIGN.LEFT}
            color={TEXT_INFO_COLOR.WHITE}
            size={TEXT_INFO_SIZE.TITLE2}
            fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
            className="title"
          />
          <TextInfo
            text={sectionLeft.description}
            kind={TEXT_INFO_KIND.SPAN}
            align={TEXT_INFO_ALIGN.LEFT}
            color={TEXT_INFO_COLOR.WHITE}
            size={TEXT_INFO_SIZE.TITLE7}
            fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
            className="description"
          />
          <CustomLink href={sectionLeft.hrefLink} forceExternal>
            <TextInfo
              text={sectionLeft.textLink}
              kind={TEXT_INFO_KIND.SPAN}
              color={TEXT_INFO_COLOR.WHITE}
              size={TEXT_INFO_SIZE.CAPTION1}
              fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
            />
          </CustomLink>
        </div>
        <div className="sectionRight">
          <TextInfo
            text={sectionRight.title}
            kind={TEXT_INFO_KIND.HEADING}
            level={TEXT_INFO_HEADING_LEVEL.H2}
            align={TEXT_INFO_ALIGN.LEFT}
            color={TEXT_INFO_COLOR.WHITE}
            size={TEXT_INFO_SIZE.TITLE2}
            fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
            className="title"
          />
          <TextInfo
            text={sectionRight.description}
            kind={TEXT_INFO_KIND.SPAN}
            align={TEXT_INFO_ALIGN.LEFT}
            color={TEXT_INFO_COLOR.WHITE}
            size={TEXT_INFO_SIZE.TITLE7}
            fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
            className="description"
          />
          <CustomLink
            className="featureISR-link"
            href={sectionRight.hrefLink}
            forceExternal
          >
            <TextInfo
              text={sectionRight.textLink}
              kind={TEXT_INFO_KIND.SPAN}
              color={TEXT_INFO_COLOR.WHITE}
              size={TEXT_INFO_SIZE.CAPTION1}
              fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
            />
          </CustomLink>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ModuloContratar;

ModuloContratar.propTypes = {
  sectionLeft: PropTypes.object,
  sectionRight: PropTypes.object,
};
ModuloContratar.defaultProps = {
  sectionLeft: {},
  sectionRight: {},
};
